module.exports = __webpack_public_path__ + "img/2009-2.bf592ab6.jpg";